import { partnerManagerActions } from "./PartnerManagerReducer";
import { usePartnerAPI  } from '../../../api/partner/usePartnerAPI';

export const usePartnerManager = () => {
    const api = usePartnerAPI();
  
    const request = {
        get: (params) => {
          return async (dispatch) => {
            try {
              const response = await api.partnerManager.get(params);
              dispatch(partnerManagerActions.funGetPartnerManager(response));
            } catch (error) {
              console.error('Error fetching data:', error);
            }
          }
        },
        post: async (data) => {
          return await api.partnerManager.post(data);
        },
        put: async (data) => {
          return await api.partnerManager.put(data);
        },
        delete: async (params) => {
          return await api.partnerManager.delete(params);
        }
    };
    return { request };
  };